import React, { Suspense } from 'react'
// import Routes from './routes/routes.router'
import './App.css'
import { ConnectedRouter } from 'connected-react-router'
import { Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'
import Routes from './router'
import { history, store } from './redux/store'

// import ContentLoader from './components/content-loader/content-loader'

function App() {
  const queryClient = new QueryClient()
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback="loading">
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Switch>
              <Routes />
            </Switch>
          </ConnectedRouter>
        </Provider>
      </Suspense>
    </QueryClientProvider>
  )
}

export default App
